import { Button, Grid } from "@mui/material";
import clsx from "clsx";
import React, { memo, useState } from "react";
import { makeStyles } from "@mui/styles";
import DialogCustoms from "../CustomDialog/DialogCustoms";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import { getData } from "../../utils/GlobalHelper";
import DialogError from "../../components/CustomDialog/DialogWait";
import { isEmpty } from "lodash";
const useStyle = makeStyles({
  btnCol_2: {
    width: "47% !important",
  },
  flexCol_2: {
    display: "flex",
    justifyContent: "space-between",
  },
});
const ButtonConcent = (props) => {
  const classes = useStyle();
  const [isModel, setIsModel] = useState(false);
  const [isModelFIF, setIsModelFIF] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง"
  );
  const checkuserinfo = getData("checkuserinfo");
  const {
    textOk,
    textCancel,
    onNextPage,
    isDisbled,
    hide,
    tcconfirm,
    pdpa,
    term,
    ndid,
    fifconsent
  } = props;
  const modelCancel = () => {
    if (tcconfirm || ndid || fifconsent) {
      try {
        const HeaderManp = getData("HeaderManp");
        GlobalApi.post(`${Configs.baseAPIURL03}/form/signed_tnc/manp`, {
          head_token: HeaderManp.head_token,
          product_id: null,
          comfrimation: 0,
          code: checkCode(),
        }).then((res) => {
          let stp = ndid ? "2" : "1";
          let errCode = ndid ? "1003" : "1002";
          let data = {};
          data.head_token = !isEmpty(HeaderManp.head_token) ? HeaderManp.head_token : "";
          data.card_id = !isEmpty(checkuserinfo?.cardId) ? checkuserinfo?.cardId : "";
          data.stamp_page = stp;
          data.error_code = errCode;
          let upd = updateTracking(data);
          if (upd) {

            if (fifconsent){
              setIsModelFIF(true);
            }else{
              setIsModel(true);
            }

          }
        });
      } catch (error) {}
    } else {
      setIsModel(true);
    }
  };
  const checkCode = () => {
    if (tcconfirm) {
      return "AGBR";
    } else if (pdpa) {
      return "PDPA";
    } else if (term) {
      return "TNC";
    } else if (ndid) {
      return "NDID";
    } else if (fifconsent) {
      return "FIFCONSENT";
    }
  };
  const updateTracking = async (data) => {
    let upd = false;
    if (!isEmpty(data)) {
      try {
        await GlobalApi.post(
          Configs.baseAPIURL03 + "/form/header/update_tracking",
          data
        )
          .then((res) => {
            let result = res.data.Data[0][0];
            upd = result.MsgDesc.includes("Success") ? true : false;
          })
          .catch((error) => {
            if (!!error.isAxiosError && !error.response) {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
              setIsModalError(true);
            } else {
              let errorMessage = error.response
                ? error.response.data.message
                : "";
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(`axios or api error ${errorMessage}`);
              setIsModalError(true);
            }
          });
      } catch (error) {
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
        setIsModalError(true);
      }
    }
    return upd;
  };
  return (
    <Grid
      className={clsx(
        hide && "hide",
        textOk && textCancel && classes.flexCol_2,
        "box-btn-next "
      )}
    >
      {textCancel && (
        <Button
          className={clsx(
            textOk && classes.btnCol_2,
            "btn-secondary-cancel",
            "font-20",
            isDisbled && "disabled"
          )}
          onClick={(e) => modelCancel()}
          disabled={isDisbled}
        >
          {textCancel}
        </Button>
      )}
      {textOk && (
        <Button
          className={clsx(
            textCancel && classes.btnCol_2,
            "btn-primary",
            "font-20",
            isDisbled && "disabled"
          )}
          onClick={(e) => onNextPage(e)}
          disabled={isDisbled}
        >
          {textOk}
        </Button>
      )}
      <DialogCustoms
        open={isModel}
        isModel={setIsModel}
        imgModalError
        title={"ขออภัย"}
        massage={
          "ไม่สามารถเปิดบัญชีออนไลน์ได้ กรุณาติดต่อ DAOL Contact Center 0 2351 1800"
        }
        btnPrimary={"ตกลง"}
      />
      <DialogCustoms
        open={isModelFIF}
        isModel={setIsModelFIF}
        imgModalError
        title={"ขออภัย ท่านไม่สามารถเปิดบัญชีออนไลน์ได้"}
        massage={
          "กรุณาติดต่อ DAOL Contact Center <span style=\"white-space: nowrap\">0 2351 1800</span><br />หากต้องการดำเนินการต่อ กรุณาคลิกยอมรับ"
        }
        btnPrimary={"ตกลง"}
      />
      <DialogError
        open={isModalError}
        isModel={setIsModalError}
        title={modalErrorTitle}
        massage={modalErrorDes}
        btn={"ตกลง"}
      />
    </Grid>
  );
};
export default memo(ButtonConcent);
